export const SAME_FN_SAMPLE_ID_DIALOG_TITLE = 'Använda medeltal?'
export const SAME_FN_SAMPLE_ID_DIALOG_BODY = 'Samma Prov ID har angivits för vänster och höger, vill du använda medeltal?'